import React from "react"
import ErrorReport from "../../components/ErrorReport"

const NotFound = () => (
  <div className="NotFound content">
    <ErrorReport
      title="Hmm..."
      subtitle="The page you are looking for doesn't seem to exist"
      code={404}
    />
  </div>
)

export default NotFound
